const getErrorMessage = (error: any): string => {
  let errorMessage = 'An unexpected error occurred. Please try again.';

  if (error.response) {
    // Extract the error message from response
    errorMessage =
      error.response.data?.user_message || // Prefer user-friendly message
      error.response.data?.message || // Fallback to generic API message
      'Something went wrong, please try again.'; // Final fallback
  } else if (error.request) {
    errorMessage = 'Network error, please check your connection.';
  } else {
    errorMessage = error.message;
  }

  return errorMessage;
};

export default getErrorMessage;
